import * as React from 'react';

import ClearBadge16 from './ClearBadge16';

export const clearBadge16 = () => <ClearBadge16 />;

export default {
    title: 'Icon/Fill/ClearBadge16',
    component: ClearBadge16,
    parameters: {
        notes: "`import ClearBadge16 from 'box-ui-elements/es/icon/fill/ClearBadge16';`",
    },
};
